import {Formik, Form, FormikHelpers} from 'formik'
import * as Yup from 'yup'
import toast from 'react-hot-toast'
import FormikControl from '../../../components/formikControl/FormikControl'
import {useQuery} from 'react-query'
import {fetchStudentList} from '../student/api'
import {Student} from '../student/type'
import {RunnerBall} from '../../../components/FormLoader'
import FormResetBtn from '../../../components/FormResetBtn'
import FormSubmitBtn from '../../../components/FormSubmitBtn'
import {linkStudentToGuardian} from './api'
import {handleApiError} from '../../../helpers/errorHandler'

type LinkStudentFormType = {student_id: string; relation?: string}

const formInitialValues: LinkStudentFormType = {
  student_id: '',
  relation: '',
}

const valdiationSchema: Yup.Schema<LinkStudentFormType> = Yup.object({
  student_id: Yup.string().required('Student is required'),
  relation: Yup.string(),
})

function LinkStudentToGuardian({
  onAfterSubmit,
  initialValues,
}: {
  onAfterSubmit: () => void
  initialValues?: {existingLinkedStudents: []; parent_id: string | number}
}) {
  const {data, isFetching} = useQuery({
    queryKey: 'studentList',
    queryFn: () => fetchStudentList({studentClass: '', division: ''}),
    initialData: [],
    refetchOnWindowFocus: false,
    keepPreviousData: true,
  })

  const submitHandler = async (
    values: LinkStudentFormType,
    {setSubmitting}: FormikHelpers<any>
  ) => {
    const toastId = toast.loading('Submitting')

    try {
      await linkStudentToGuardian({
        student_id: values.student_id,
        parent_id: initialValues?.parent_id!,
        relation: values.relation!,
      })
      toast.success('Success', {id: toastId})
      onAfterSubmit()
    } catch (err: any) {
      handleApiError(err, toastId)
    } finally {
      setSubmitting(false)
    }
  }

  if (isFetching) {
    return <RunnerBall />
  }
  const formValues = formInitialValues

  const existingStudentIds = new Set(
    initialValues?.existingLinkedStudents.map((student: any) => student.student_id)
  )

  const nonexistingLinkedStudents = data.data.filter(
    (student: Student) => !existingStudentIds.has(student.student_id)
  )

  return (
    <div className="px-5 py-3">
      <Formik<LinkStudentFormType>
        initialValues={formValues}
        validationSchema={valdiationSchema}
        onSubmit={submitHandler}
      >
        {({isSubmitting, resetForm, values, dirty, isValid}) => (
          <Form>
            <FormikControl
              options={nonexistingLinkedStudents}
              optionLabel="student_name"
              optionValue="student_id"
              control="select-advanced"
              value={
                data.data.find(
                  (student: Student) => student.student_id === Number(values.student_id)
                ) || null
              }
              required
              placeholder="Student"
              label="Student"
              name="student_id"
            />
            {/* <FormikControl
              name="relation"
              control="input"
              placeholder="Relation"
              label="Relation"
            /> */}
            <FormikControl control="select" name="relation" label="Relation">
              <option value="">Select Relation</option>
              <option value="father">Father</option>
              <option value="mother">Mother</option>
              <option value="guardian">Guardian</option>
              <option value="other">Other</option>
            </FormikControl>
            <div className="text-center pt-10">
              <FormResetBtn onClick={() => resetForm} disabled={isSubmitting} className="me-4" />

              <FormSubmitBtn disabled={!dirty || !isValid || isSubmitting} />
            </div>
          </Form>
        )}
      </Formik>
    </div>
  )
}

export default LinkStudentToGuardian
